import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo, useState } from 'react';

// Shares the customer-footer DOM node between CustomerFooter (the owner) and
// peers that need to attach listeners or observers to it (MobileKeyboardKeepAlive).
// State, not a ref, so consumers re-render when the node mounts or unmounts.
const CustomerFooterRefContext = createContext({ footerNode: null, setFooterNode: () => {} });

export function CustomerFooterRefProvider({ children }) {
  const [footerNode, setFooterNode] = useState(null);
  const value = useMemo(() => ({ footerNode, setFooterNode }), [footerNode]);
  return <CustomerFooterRefContext.Provider value={value}>{children}</CustomerFooterRefContext.Provider>;
}

CustomerFooterRefProvider.propTypes = {
  children: PropTypes.node,
};

export function useCustomerFooterRef() {
  return useContext(CustomerFooterRefContext);
}

export default CustomerFooterRefContext;
